<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ 'GERUESTANFRAGE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16 margin-bottom-64">

    @if (showConfirmation()) {
      <div class="work-card padding-16 flex flex-column gap-16">
        <h2>{{ 'GERUESTANFRAGE_DANKE_TITEL' | translate }}</h2>
        <p>{{ 'GERUESTANFRAGE_DANKE_TEXT' | translate }}</p>
      </div>
    } @else {
      <work-ui-form-wizard [formGroupInput]="form" [completeButtonLabel]="'GERUESTANFRAGE_SENDEN'" (complete)="submitForm()">
        <form [formGroup]="form" autocomplete="off">

          <!-- ═══ Step 1: Objektadresse ═══════════════════════════════════════════ -->
          <ng-template workUiFormWizardStep stepTitle="GERUESTANFRAGE_OBJEKTADRESSE">
            <div class="work-card work-card--success margin-bottom-24">
              <p>{{ 'GERUESTANFRAGE_INTRO' | translate }}</p>
            </div>

            <div class="flex flex-column gap-16">
              <div class="work-card padding-16">
                <div class="flex flex-column gap-12">
                  <work-ui-input-field
                    formControlName="strasse"
                    label="STRASSE"
                    type="text"
                    [required]="true" />
                  <work-ui-input-field
                    formControlName="plz"
                    label="PLZ_KURZ"
                    type="text"
                    [required]="true" />
                  <work-ui-input-field
                    formControlName="ort"
                    label="ORT"
                    type="text"
                    [required]="true" />
                </div>
              </div>
            </div>
          </ng-template>

          <!-- ═══ Step 2: Fotos ════════════════════════════════════════════════════ -->
          <ng-template workUiFormWizardStep stepTitle="GERUESTANFRAGE_FOTOS">
            <div class="flex flex-column gap-16">
              <div class="work-card padding-16">
                <div class="flex flex-column gap-12">
                  <div class="flex flex-row gap-8">
                    <work-ui-button
                      text="KAMERA"
                      iconName="camera_alt"
                      variant="secondary"
                      [fullWidth]="true"
                      (buttonClick)="takePhoto()" />
                    <work-ui-button
                      text="GALLERIE"
                      iconName="photo_library"
                      variant="secondary"
                      [fullWidth]="true"
                      (buttonClick)="pickFromGallery()" />
                  </div>
                  @if (capturedPhotos().length > 0) {
                    <div class="photo-grid">
                      @for (photo of capturedPhotos(); track $index) {
                        <div class="photo-item">
                          <img [src]="photo.dataUrl" [alt]="photo.fileName" class="photo-preview" />
                          <work-ui-button
                            (buttonClick)="removePhoto($index)"
                            [iconOnly]="true"
                            iconName="close"
                            size="small"
                            variant="secondary"
                            class="photo-remove-btn" />
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </ng-template>

          <!-- ═══ Step 3: Kontaktangaben ══════════════════════════════════════════ -->
          <ng-template workUiFormWizardStep stepTitle="GERUESTANFRAGE_KONTAKT">
            <div class="flex flex-column gap-16">
              <div class="work-card padding-16">
                <div class="flex flex-column gap-12">
                  <work-ui-input-field
                    formControlName="vorname"
                    label="VORNAME"
                    type="text"
                    [required]="true" />
                  <work-ui-input-field
                    formControlName="nachname"
                    label="NACHNAME"
                    type="text"
                    [required]="true" />
                  <work-ui-input-field
                    formControlName="email"
                    label="EMAIL"
                    type="email"
                    [required]="true" />
                  <work-ui-input-field
                    formControlName="telefon"
                    label="TELEFON"
                    type="tel"
                    [required]="true" />
                </div>
              </div>
            </div>
          </ng-template>

        </form>
      </work-ui-form-wizard>
    }

  </div>
</ion-content>
